// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".status_dot[data-v-65dbcf96]{height:10px;width:10px;border-radius:50%;display:inline-block}tbody tr[data-v-65dbcf96]:nth-of-type(odd){background-color:rgba(0,0,0,.02)}.problem_link[data-v-65dbcf96]{text-decoration:none;color:#000}.v-data-table td[data-v-65dbcf96]{height:64px}.link_btn[data-v-65dbcf96]{color:#33a79d;text-decoration:none}", ""]);
// Exports
module.exports = exports;
